import { personasServices } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/services/personas.service';
import { personasRepositoryInstance } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/instances/personasRepository';
import { createGetPatientsExtraInfoService } from '../create-get-patients-extra-info.service';
import { PatientVisit } from '../../../ts';

const fetchFunction = personasServices(personasRepositoryInstance).getAllPatientVisits;

export const getPatientsVisitsService =
  createGetPatientsExtraInfoService<PatientVisit>(fetchFunction);
